/* istanbul ignore file */

const information = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Information</title>
    <g clipPath="url(#clip0_2232_121557)">
      <path
        d="M12 0C5.3728 0 0 5.3728 0 12C0 18.6272 5.3728 24 12 24C18.6272 24 24 18.6272 24 12C24 5.3728 18.6272 0 12 0ZM13.5 19.5H10.5V10.5H13.5V19.5ZM12 8.1C11.4696 8.1 10.9609 7.88929 10.5858 7.51421C10.2107 7.13914 10 6.63043 10 6.1C10 5.56957 10.2107 5.06086 10.5858 4.68579C10.9609 4.31071 11.4696 4.1 12 4.1C12.5304 4.1 13.0391 4.31071 13.4142 4.68579C13.7893 5.06086 14 5.56957 14 6.1C14 6.63043 13.7893 7.13914 13.4142 7.51421C13.0391 7.88929 12.5304 8.1 12 8.1Z"
        fill="#0C8DC3"
      />
    </g>
    <defs>
      <clipPath id="clip0_2232_121557">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default information;
